// @ts-nocheck
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { CardItemSelector, LoadingSkeleton } from 'sonata-react-components';

import { ReportingShareReportModalContext } from '../ReportingShareReportModalContext';

import './reportingSharedPermissionsSelector.scss';

function ReportingSharedPermissionsSelector() {
  const { selectedSharedReportPermission, setContext, sharedReportPermissions } = useContext(
    ReportingShareReportModalContext
  );

  const [{ defaultItem, items }, setState] = useState({
    defaultItem: [],
    items: []
  });

  useEffect(() => {
    if (sharedReportPermissions && sharedReportPermissions.length) {
      const selectableItems = sharedReportPermissions.map(permissionTier => ({
        backgroundSelectedColor: permissionTier.backgroundSelectedColor,
        borderSelectedColor: permissionTier.borderSelectedColor,
        bottomColor: permissionTier.color,
        description: permissionTier.description,
        iconDefault: permissionTier.icon || 'fal fa-file-alt',
        isDefault: permissionTier.isDefault,
        label: permissionTier.name,
        permissionsLength: permissionTier.permissions.length,
        subtitle: permissionTier.subtitle,
        tagContent: permissionTier.tagContent,
        value: permissionTier._id
      }));

      const toSetDefaultItem = selectableItems.find(i => i.isDefault) || selectableItems[0];
      setState(prevState => ({
        ...prevState,
        defaultItem: toSetDefaultItem ? [toSetDefaultItem.value] : [],
        items: selectableItems.sort((a, b) => a.permissionsLength - b.permissionsLength)
      }));
      setContext(prevState => ({
        ...prevState,
        defaultSharedReportPermission: toSetDefaultItem ? [toSetDefaultItem.value] : [],
        ...(toSetDefaultItem && { selectedSharedReportPermission: [toSetDefaultItem.value] })
      }));
    }
  }, [sharedReportPermissions, setContext]);

  const onChanged = useCallback(
    permissionTierId => {
      setContext(prevContext => ({
        ...prevContext,
        selectedSharedReportPermission: permissionTierId
      }));
    },
    [setContext]
  );

  return (
    <div className="reportingSharedPermissionsSelector">
      {sharedReportPermissions && items.length ? (
        <CardItemSelector
          defaultValues={defaultItem}
          id="reporting_shared_permissions_selector"
          items={items}
          onChange={onChanged}
          selectedItems={selectedSharedReportPermission}
        />
      ) : (
        <div className="loadingSkeletonContainer">
          {Array.from(Array(3).keys()).map(i => (
            <LoadingSkeleton count={1} height={200} key={i} />
          ))}
        </div>
      )}
    </div>
  );
}

export default React.memo(ReportingSharedPermissionsSelector);
